import { Typography } from "@mui/material";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

/** The picker's one-line status in place of a list: loading, a hint, or no results. */
export const ChatUserSearchMessage = ({ children }: Props) => (
  <Typography variant="body2" color="text.secondary">
    {children}
  </Typography>
);
